"use client"

import ContactBox from "@/ui/common/ContactBox"
import styled from "@emotion/styled"
import { Box } from "@mui/material"
import { useInView } from "react-intersection-observer"
import {
  transitionDelayTime,
  useInViewConfig,
  useIsDesktop,
  useTransitionUpStyles,
} from "ui"
import CommonTitle from "ui/common/bit/CommonTitle"
import { mediaQueries } from "ui/theme/mediaQueries"
import { colors, sizes } from "ui/theme/theme"
import { extractMenuProperties } from "utils"
import { sendBlockEvent } from "utils/gtm"
import EnhancedTypography from "../common/bit/EnhancedTypography"
import BlockWrapper from "../common/BlockWrapper"

const StyledListContainer = styled(Box)`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  ${mediaQueries.desktopM} {
    gap: 12px;
    flex-direction: row;
  }
  ${mediaQueries.desktopXl} {
    gap: 32px;
  }
`
const StyledCommonTitle = styled(CommonTitle)`
  ${mediaQueries.mobile} {
    margin-bottom: ${sizes.baseSix};
  }
`

const StyledHours = styled(EnhancedTypography)`
  font-weight: 400;
`

const StyledTextContainer = styled(Box)`
  ${mediaQueries.mobile} {
    padding: 48px 70px 0 70px;
    line-height: 1.8;
  }
  ${mediaQueries.tablet} {
    padding: 50px 70px 0 70px;
    line-height: 1.8;
  }
  ${mediaQueries.desktop} {
    padding: 70px 70px 0 70px;
  }
`

const ContactClient = ({ data, id }: any) => {
  const isDesktop = useIsDesktop()
  const { title, subtitle, boxesList, text } = data
  const { ref: listRef, inView: listInView } = useInView(useInViewConfig)
  const { ref: textRef, inView: textInView } = useInView(useInViewConfig)
  const listTransitionStyles = useTransitionUpStyles(
    listInView,
    transitionDelayTime,
  )
  const textTransitionStyles = useTransitionUpStyles(
    textInView,
    transitionDelayTime,
  )

  return (
    <BlockWrapper id={id} alignItems="center">
      {(title || subtitle) && (
        <StyledCommonTitle title={title?.value} subtitle={subtitle?.value} />
      )}
      <StyledListContainer ref={listRef} style={{ ...listTransitionStyles }}>
        {boxesList &&
          boxesList?.blocks?.map((box: any, index: number) => {
            const delay = index * 200 // Add delay of 200ms between boxes
            const {
              icon,
              title: boxTitle,
              url,
              primaryColor,
            } = extractMenuProperties(box)

            const contactBoxData = {
              icon,
              title: boxTitle,
              url,
              primaryColor,
              delay,
              isInView: listInView,
            }

            return (
              <ContactBox
                key={`contact-client-${index}`}
                data={contactBoxData}
                onClick={(buttonName) => {
                  sendBlockEvent({
                    blockId: id || "10",
                    componentName: "צור קשר",
                    title: title?.value || "אנחנו בכל ערוץ",
                    buttonName,
                    productName: data?.formDefaultInsuranceType,
                  })
                }}
              />
            )
          })}
      </StyledListContainer>
      {text && (
        <StyledTextContainer ref={textRef} style={{ ...textTransitionStyles }}>
          <StyledHours
            variant="h5"
            component="p"
            textAlign={"center"}
            color={colors.black}
          >
            {text?.value}
          </StyledHours>
        </StyledTextContainer>
      )}
    </BlockWrapper>
  )
}

export default ContactClient
